import { createAsyncThunk } from '@reduxjs/toolkit';
import { _teleModPriceUrls } from '@custom/Utils/constants/apiUrls';

type deletePayloadType = {
  _id: string;
};

// Async thunk to delete a teleradiology modality price
export const deleteTeleModPrice = createAsyncThunk(
  'deleteTeleModPrice',
  async (payload: deletePayloadType, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await fetch(_teleModPriceUrls?.delete, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response?.ok) {
        return rejectWithValue(`Failed to delete modality price. Status code: ${response?.status}`);
      }

      return await response.json(); // Return the response data if successful
    } catch (error: any) {
      return rejectWithValue(error.message); // Handle any errors that occur
    }
  }
);

// You can export both thunks together if needed
export default deleteTeleModPrice;
